import { makeStyles } from '@material-ui/core/styles';
import { MediaQuery } from 'static/styles/jss/abstracts/mixins';
import variables from 'static/styles/jss/abstracts/variables';

export default makeStyles({
  'page-title--block': {
    textAlign: 'center',
    padding: '70px 0 120px',
    '& h3': {
      fontSize: '40px',
      marginBottom: '30px',
    },
    '& p': {
      fontSize: '15px',
      color: variables.$helperTextColor,
    },
    ...MediaQuery.down({
      padding: '20px 0 50px',
      '& h3': {
        fontSize: '24px',
        marginBottom: '20px',
      },
    }).sm,
  },
});
